<template>
  <div>
    <ca-loader v-if="showLoading"></ca-loader>
    <ca-form
      v-else
      :key="formKey"
      ref="caForm"
      :on-submit="() => {}"
      :is-valid.sync="isFormValid">
      <ca-row vertical-offset="4">
        <ca-col>
          <ca-heading text="Dados básicos" size="medium"></ca-heading>
        </ca-col>
      </ca-row>
      <ca-row-divider margin-bottom="medium"></ca-row-divider>
      <worker-basic-data-tab
        :worker-registration="workerRegistration"
        :picture="workerRegistrationPicture"
        :worker-id="workerBasicInfo.id"
        @refresh-form="refreshForm"
        @picture-selected="onPictureSelected"
        @update-preview-picture="onUpdatePreviewPicture"></worker-basic-data-tab>

      <ca-row vertical-offset="4">
        <ca-col>
          <ca-heading text="Documentos" size="medium"></ca-heading>
        </ca-col>
      </ca-row>
      <ca-row-divider margin-bottom="medium"></ca-row-divider>
      <worker-documents-tab
        :worker-registration="workerRegistration"
        @refresh-form="refreshForm"></worker-documents-tab>

      <ca-row vertical-offset="4">
        <ca-col>
          <ca-heading text="Endereço" size="medium"></ca-heading>
        </ca-col>
      </ca-row>
      <ca-row-divider margin-bottom="medium"></ca-row-divider>
      <worker-address-tab
        :worker-registration="workerRegistration"
        @refresh-form="refreshForm"></worker-address-tab>

      <ca-row vertical-offset="4">
        <ca-col>
          <ca-heading text="Dependentes" size="medium"></ca-heading>
        </ca-col>
      </ca-row>
      <ca-row-divider margin-bottom="medium"></ca-row-divider>
      <worker-dependents-tab></worker-dependents-tab>

      <ca-row vertical-offset="4">
        <ca-col>
          <ca-heading text="Anexos" size="medium"></ca-heading>
        </ca-col>
      </ca-row>
      <ca-row-divider margin-bottom="medium"></ca-row-divider>
      <worker-attachments-tab :is-edit-mode="true"></worker-attachments-tab>

      <ca-row vertical-offset="4">
        <ca-col>
          <ca-heading text="Adicionais" size="medium"></ca-heading>
        </ca-col>
      </ca-row>
      <ca-row-divider margin-bottom="medium"></ca-row-divider>
      <worker-additional-options-tab
        :worker-registration="workerRegistration"
        @refresh-form="refreshForm"></worker-additional-options-tab>
    </ca-form>
  </div>
</template>

<script>
import { WorkerPersonalDataMixin } from 'accountant/worker/src/modules/workers/mixins/WorkerPersonalDataMixin';
import store from '../../../../../../store/index';

export default {
  name: 'WorkerPersonalDataForm',
  mixins: [
    WorkerPersonalDataMixin,
  ],
  data() {
    return {
      formKey: 0,
      errorMessage: null,
      isFormValid: true,
    };
  },
  computed: {
    workerBasicInfo() {
      return store.state.worker.basicInfo;
    },
    workerId() {
      return this.workerBasicInfo.id;
    },
  },
  watch: {
    isFormValid(value) {
      this.$emit('on-is-form-valid', value);
    },
    workerRegistration: {
      deep: true,
      handler(value) {
        this.$emit('update-personal-data', value);
      },
    },
  },
  created() {
    this.initDataMixin();
    this.showLoading = false;
  },
  methods: {
    async refreshForm() {
      this.$refs.caForm.modelValidators = [];
      await this.$nextTick();
      this.formKey++;
    },
  },
};
</script>
